export enum DeviceTypeEnum {
  DesktopLarge = 'desktop-large',
  DesktopSmall = 'desktop-small',
  Laptop = 'laptop',
  Tablet = 'tablet',
  Mobile = 'mobile',
}

export enum PagesEnum {
  Home = 'home',
  School = 'school',
  Courses = 'courses',
  CourseDetails = 'courseDetails',
  FreeConsultation = 'freeConsultation',
}

export enum AccessibilityModeEnum {
  Regular = 'regular',
  Enhanced = 'enhanced',
}

export enum ThemeEnum {
  Light = 'light',
  Dark = 'dark',
  Basic = 'basic',
}

export enum TextSizeEnum {
  Small = 'small',
  Medium = 'medium',
  Large = 'large',
}
